import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { SERVICES } from "@/data/site";

const Services = () => (
  <div data-testid="services-page">
    <Seo
      title="Our Services — Cloud, Containers, Apps & Security | TecKube"
      description="TecKube's four service areas: Cloud & DevOps, Containerization & Orchestration, Web & Mobile Application Development and Cybersecurity, in one offering."
    />
    <PageHero
      eyebrow="Our Services"
      title="From initial requirement to working solution."
      lead="TecKube brings these disciplines into one service offering, helping you move from an initial requirement to a working solution that your team can operate and maintain."
    />

    <section className="bg-paper pb-24 md:pb-32" data-testid="services-list">
      <div className="mx-auto max-w-7xl px-6">
        {SERVICES.map((service, i) => (
          <Reveal key={service.slug} delay={0.05}>
            <Link
              to={`/services/${service.slug}`}
              data-testid={`services-row-${service.slug}`}
              className="group grid items-center gap-10 border-t border-slate-200 py-14 md:grid-cols-12 md:py-20"
            >
              <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <span className="font-mono text-xs tracking-[0.25em] text-primary">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="mt-4 font-display text-[clamp(1.7rem,3vw,2.6rem)] font-semibold leading-[1.08] tracking-tight text-ink">
                  {service.title}
                </h2>
                <p className="mt-4 max-w-lg text-lg leading-relaxed text-soot">
                  {service.tagline}
                </p>
                <span className="mt-7 inline-flex items-center gap-2 font-display text-[15px] font-semibold text-primary">
                  Explore service
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </span>
              </div>
              <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <div className="overflow-hidden rounded-3xl border border-slate-200 shadow-[0_24px_60px_-30px_rgba(15,23,42,0.3)]">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                  />
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>

    <CTABand />
  </div>
);

export default Services;
